<div class="component-wrapper">
<form [formGroup]="contactDataForm">
    <kontakt-new class="ansprechpartner-input" [form]="contactDataForm.Ansprechpartner" kontakttyp="ansprechpartner" [isRequired]="true" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked"
        ></kontakt-new>

    <div class="mt-4">
        <kendo-formfield class="cbweitererAnsprechpartner">
            <div class="k-checkbox-wrap">
                <input id="cbweitererAnsprechpartner" #cbweitererAnsprechpartner type="checkbox" kendoCheckBox
                    formControlName="cbweitererAnsprechpartner" [attr.aria-label]="'contact-data.additionalContactPersonTitle' | translate" />
                <label for="cbweitererAnsprechpartner"
                    class="k-checkbox-label ansprechpartner3-heading" [attr.aria-label]="'contact-data.additionalContactPersonTitle' | translate" translate>
                    contact-data.additionalContactPersonTitle
                </label>
            </div>
        </kendo-formfield>
        <div *ngIf="cbweitererAnsprechpartner.checked" class="ansprechpartner2 mt-3">
            <kontakt-new class="ansprechpartner2-input" [form]="contactDataForm.WeitererAnsprechpartner"
                kontakttyp="weitereransprechpartner" [isWeitererAnsprechpartnerChecked]="weitererAnsprechpartnerChecked">
            </kontakt-new>
        </div>
    </div>
</form>